module.exports = __webpack_public_path__ + "img/logo2.40f53ea6.png";